import IEnv from "./interface";

const getEnv = (key: string) => {
  if (
    typeof window !== "undefined" &&
    typeof (window as any).__APP_ENV__ === "object" &&
    (window as any).__APP_ENV__[key] !== undefined
  ) {
    return (window as any).__APP_ENV__[key];
  }
  return process.env[key];
};

export const env: IEnv = {
  title: getEnv("REACT_APP_TITLE"),
  url: getEnv("REACT_APP_URL_HOST"),
  node: getEnv("REACT_APP_NODE_ENV"),
  port: getEnv("REACT_APP_PORT"),
  analytic: getEnv("REACT_ANALYTICS_KEY"),
  version: getEnv("REACT_APP_VERSION"),
  google: {
    client_key: getEnv("REACT_APP_GOOGLE_CLIENT_KEY"),
  },
  url_dev: getEnv("REACT_APP_URL_DEV"),
  url_prd: getEnv("REACT_APP_URL_PRD"),
  key_storage: getEnv("REACT_APP_KEY_STORAGE") || "",
  key_hash: getEnv("REACT_APP_KEY_HASH"),
  title_system: getEnv("REACT_APP_TITLE_SYSTEM"),
};
